export const endpoints = {
    sanctum: '/sanctum/csrf-cookie',
    auth: {
        login: '/api/v1/auth/login',
        register: '/api/v1/auth/register',
        logout: '/api/v1/auth/logout',
        verifyMfa: '/api/v1/auth/2fa/confirm',
        sendMfaCodeEmail: '/api/v1/auth/2fa/code-by-email',
        sendMfaCodeSMS: '/api/v1/auth/2fa/code-by-sms',
        resetPassword: '/api/v1/auth/password/reset',
        restorePassword: '/api/v1/auth/password/restore',
        restorePasswordLink: '/api/v1/auth/password/restore-link',
        restorePasswordLinkEmail: '/api/v1/auth/password/restore-link-email',
        refreshToken: '/api/v1/auth/refresh',
        user: '/api/v1/auth/user',
        twoFactorSettings: '/api/v1/auth/2fa/settings'
    },
    configuration: {
        index: '/api/v1/configuration',
        updateMany: '/api/v1/configuration',
        priceAndThresholdsConfiguration: '/api/v1/configuration/pricing-thresholds-configuration',
        gratuityConfiguration: '/api/v1/configuration/gratuity-percent',
        baseHourlyPriceConfiguration: '/api/v1/configuration/base-hourly-price',
        recruitingGeocoding: '/api/v1/configuration/recruiting-geocoding'
    },
    dashboad: {
        admin: {
            revenueSummary: '/api/v1/admin/dashboard/revenue-summary',
            driversRating: '/api/v1/admin/dashboard/drivers-rating',
            bookingsHeatmap: '/api/v1/admin/dashboard/bookings-heatmap',
            bookingsTrend: '/api/v1/admin/dashboard/bookings-trend',
            topPickupAddresses: '/api/v1/admin/dashboard/top-pickup-addresses',
            topDropoffAddresses: '/api/v1/admin/dashboard/top-dropoff-addresses',
            bookingsByType: '/api/v1/admin/dashboard/bookings-by-type'
        }
    },
    bookings: {
        list: '/api/v1/bookings',
        create: '/api/v1/bookings',
        listBookingsOnBillingReview: '/api/v1/bookings/bookings_in_billing_review',
        batchSettleOnBillingReview: '/api/v1/bookings/batch-settle',
        update: (booking: string | undefined) => `/api/v1/bookings/${booking}`,
        show: (booking: string | undefined) => `/api/v1/bookings/${booking}`,
        updateTripNotes: (bookingID: string | undefined) => `api/v1/bookings/${bookingID}/trip-notes`,
        updateOffering: (bookingID: string | undefined) => `api/v1/bookings/${bookingID}/offering`,
        assignDriver: (bookingID: string | undefined) => `api/v1/bookings/${bookingID}/assign-driver`,
        availableDrivers: (bookingID: string) => `/api/v1/bookings/${bookingID}/available-drivers`,
        updateStatusAndDriver: (bookingID: string) => `/api/v1/bookings/${bookingID}/status-driver`,
        getBookingLog: (bookingID: string) => `/api/v1/bookings/${bookingID}/booking-log`,
        cancel: (bookingID: string) => `/api/v1/bookings/${bookingID}/cancel`,
        finalize: (bookingID: string) => `/api/v1/bookings/${bookingID}/finalize`,
        feedback: (bookingID: string) => `/api/v1/bookings/${bookingID}/feedback`,
        sendEmail: (bookingID: string) => `/api/v1/bookings/${bookingID}/email`,
        copy: (bookingID: string) => `/api/v1/bookings/${bookingID}/copy`,
        addExpenseOrDiscount: (bookingID: string) => `/api/v1/bookings/${bookingID}/expense-or-discount`,
        RemoveExpenseOrDiscount: (bookingID: string) => `/api/v1/bookings/${bookingID}/expense-or-discount/remove`,
        settleNote: (bookingID: string) => `/api/v1/bookings/${bookingID}/settle-note`,
        updatePaymentMethod: (bookingID: string) => `/api/v1/bookings/${bookingID}/payment-method`,
        authorizeAndCapture: (bookingID: string) => `/api/v1/bookings/${bookingID}/authorize-and-capture`,
        settle: (bookingID: string) => `/api/v1/bookings/${bookingID}/settle`,
        refund: (bookingID: string) => `/api/v1/bookings/${bookingID}/refund`,
        callList: (bookingID: string) => `/api/v1/bookings/${bookingID}/call-list`
    },
    users: {
        createAddress: (userID: string | undefined) => `api/v1/users/${userID}/address`,
        updateAccountStatus: (userID: string | undefined) => `api/v1/users/${userID}/account-status`,
        updateClientName: (userID: string | undefined) => `api/v1/users/${userID}/name`,
        uploadAvatar: (userID: string | undefined) => `/api/v1/users/${userID}/avatar`,
        updateRoles: (userID: string | undefined) => `api/v1/users/${userID}/roles`,
        updatePhone: (userID: string | undefined) => `api/v1/users/${userID}/phone`,
        deletePhone: (userID: string | undefined) => `api/v1/users/${userID}/delete-phone`,
        updateEmail: (userID: string | undefined) => `api/v1/users/${userID}/email`
    },
    staff_members: {
        create: '/api/v1/staff-members',
        index: '/api/v1/staff-members',
        show: (staffMember: string | undefined) => `/api/v1/staff-members/${staffMember}`,
        getDispatchedBookings: (staffMember: string) => `/api/v1/staff-members/${staffMember}/dispatched-bookings`,
        sendEmail: (staffMember: string) => `/api/v1/staff-members/${staffMember}/send-email`
    },
    drivers: {
        create: '/api/v1/drivers',
        index: '/api/v1/drivers',
        show: (driver: string | undefined) => `/api/v1/drivers/${driver}`,
        updateUnavailabilityWeek: (driver: string | undefined) => `/api/v1/drivers/${driver}/unavailability-week`,
        updateDriverInfo: (driver: string | undefined) => `/api/v1/drivers/${driver}/driver-info`,
        updateDriverSettings: (driver: string | undefined) => `/api/v1/drivers/${driver}/driver-settings`,
        updateDriverAutomaticTier: (driver: string | undefined) => `/api/v1/drivers/${driver}/driver-tier`,
        getUpcomingBookings: (driver: string) => `/api/v1/drivers/${driver}/upcoming-bookings`,
        getPastBookings: (driver: string) => `/api/v1/drivers/${driver}/past-bookings`,
        getOpenBookings: (driver: string) => `/api/v1/drivers/${driver}/open-bookings`,
        uploadDriverDocuments: (driver: string) => `/api/v1/drivers/${driver}/driver-documents`,
        updateNotes: (driver: string) => `/api/v1/drivers/${driver}/notes`,
        updateAdditionalInformation: (driver: string) => `/api/v1/drivers/${driver}/additional-information`,
        updateBankInfo: (driver: string) => `/api/v1/drivers/${driver}/bank-info`,
        createInternalFeedback: (driver: string) => `/api/v1/drivers/${driver}/feedback`,
        sendEmail: (driver: string) => `/api/v1/drivers/${driver}/send-email`
    },
    recruiting: {
        applicants: '/api/v1/recruiting/applicants',
        show: (applicant: string) => `/api/v1/recruiting/${applicant}`,
        updateStatus: (applicant: string) => `/api/v1/recruiting/${applicant}/status`,
        updateFollowUp: (applicant: string) => `/api/v1/recruiting/${applicant}/follow-up`,
        scheduleInterview: (applicant: string) => `/api/v1/recruiting/${applicant}/interview`,
        rescheduleInterview: (applicant: string, interview: number) => `/api/v1/recruiting/${applicant}/interviews/${interview}`,
        recordInterviewOutcome: (applicant: string, interview: number) => `/api/v1/recruiting/${applicant}/interviews/${interview}/outcome`,
        updateTrainingSession: (applicant: string) => `/api/v1/recruiting/${applicant}/training-session`,
        completeTrainingSession: (applicant: string) => `/api/v1/recruiting/${applicant}/training-session/complete`,
        activate: (applicant: string) => `/api/v1/recruiting/${applicant}/activate`
    },
    clients: {
        index: '/api/v1/clients',
        create: '/api/v1/clients',
        show: (client: string | undefined) => `/api/v1/clients/${client}`,
        createClientContact: (client: string | undefined) => `/api/v1/clients/${client}/contact`,
        updateClientBookingContactName: (client: string | undefined) => `/api/v1/clients/${client}/booking-contact/name`,
        deleteClientBookingContact: (client: string) => `/api/v1/clients/${client}/booking-contact`,
        addClientPassenger: (client: string | undefined) => `/api/v1/clients/${client}/passengers`,
        addClientAddress: (client: string | undefined) => `/api/v1/clients/${client}/addresses`,
        availableDrivers: (client: string) => `/api/v1/clients/${client}/available-drivers`,
        addPreferredDriver: (client: string) => `/api/v1/clients/${client}/preferred-drivers`,
        addRestrictedDriver: (client: string) => `/api/v1/clients/${client}/restricted-drivers`,
        removePreferredDriver: (client: string, driver: string) => `/api/v1/clients/${client}/preferred-drivers/${driver}`,
        removeRestrictedDriver: (client: string, driver: string) => `/api/v1/clients/${client}/restricted-drivers/${driver}`,
        updateNotes: (client: string) => `/api/v1/clients/${client}/notes`,
        updateSpecialRate: (client: string) => `/api/v1/clients/${client}/special-rate`,
        updateAccountType: (client: string) => `/api/v1/clients/${client}/account-type`,
        updatePrimaryEmail: (client: string) => `/api/v1/clients/${client}/primary-email`,
        updatePrimaryPhone: (client: string) => `/api/v1/clients/${client}/primary-phone`,
        wireTransfer: (client: string) => `/api/v1/clients/${client}/wire-transfer`,
        getBookingHistory: (client: string) => `/api/v1/clients/${client}/booking-history`
    },
    roles: {
        index: '/api/v1/roles',
        staffMemberRoles: '/api/v1/roles/staff-member-roles'
    },
    airlines: {
        index: '/api/v1/airlines'
    },
    notifications: {
        vapidPublicKey: '/api/v1/notifications/vapid-public-key',
        subscribe: '/api/v1/notifications/subscribe',
        unsubscribe: '/api/v1/notifications/unsubscribe',
        send: '/api/v1/notifications/send'
    },
    addresses: {
        airportsAddresses: 'api/v1/addresses/airports',
        update: (address: string) => `/api/v1/addresses/${address}`
    },
    userAddresses: {
        update: (userAddress: string) => `/api/v1/user-addresses/${userAddress}`,
        delete: (userAddress: string) => `/api/v1/user-addresses/${userAddress}`
    },
    contacts: {
        update: (contact: string) => `/api/v1/contacts/${contact}`,
        delete: (contact: string) => `/api/v1/contacts/${contact}`
    },
    statuses: {
        index: '/api/v1/statuses'
    },
    creditCards: {
        delete: (creditCard: string) => `/api/v1/credit-cards/${creditCard}`
    },
    passengers: {
        update: (guestPassenger: string) => `/api/v1/guest-passengers/${guestPassenger}`,
        delete: (guestPassenger: string) => `/api/v1/guest-passengers/${guestPassenger}`
    },
    driverDocuments: {
        delete: (document: string) => `/api/v1/driver-documents/${document}`,
        review: (document: string) => `/api/v1/driver-documents/${document}`
    },
    financialTransaction: {
        delete: (financialTransactionId: string) => `/api/v1/financial-transactions/${financialTransactionId}`
    },
    rateDriver: {
        showPublic: (bookingId: string) => `/api/v1/rate-driver/${bookingId}`,
        rateDriver: (bookingId: string) => `/api/v1/rate-driver/${bookingId}`
    }
};
